// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1vIok","inner":"Footer_inner__Bi0dF","nextIcon":"Footer_nextIcon__3PZhB","innerLeft":"Footer_innerLeft__Te-7X"};